// extracted by mini-css-extract-plugin
export default {"sslBadge":"styles_sslBadge__TRUC3","textContent":"styles_textContent__l6Di-","pillOrb":"styles_pillOrb__sxlHe","shieldIcon":"styles_shieldIcon__MO3rr"};